import { IconButton, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';
import uuidv4 from 'src/utils/uuidv4';

const EditComponent = (props: any) => {
  const {
    record,
    data,
    checklistItem,
    handler,
    allowEdit
  } = props?.others;

  const items = data && data.length > 0 
    ? data 
    : [{ title: '', value: '' }];

  return (
    <Stack direction="row" alignItems="center">
      <Stack direction="column" alignItems="flex-start">
        {items?.map((e) => (
         <Stack direction="row" key={uuidv4()}>
            <Typography sx={{ fontSize: 12 }}>{e?.title}: </Typography>&nbsp;
            <span style={{ fontWeight: 'bold', color: 'green', fontSize: 12 }}>{e?.value}</span>
          </Stack>
        ))}
      </Stack>
      {allowEdit &&
        <Stack direction="column" alignItems="center">
          <IconButton 
            size='small'
            onClick={ () =>
              handler({
                record,
                checklistItem
            }) }
          >
            <Iconify icon="eva:edit-outline" />
          </IconButton>
        </Stack>
      }
    </Stack>
  );
};

export default EditComponent;